import React from 'react';
import Layout from '../Layout';
import ProjectList from '../ProjectList';

export default () => (
  <Layout>
    <ProjectList />
  </Layout>
);
